import { createTheme, applyThemeColors as applySharedThemeColors } from 'kmstack-shared/constants';

export { utilityColors, effectColors } from 'kmstack-shared/constants';

// Optional app overrides belong here, so charts and CSS use the same palette.
export const themeColors = createTheme();

export function applyThemeColors() {
    applySharedThemeColors(themeColors);
}
